import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { COLORS } from '../theme'
import { warningBoxSx } from '../styles'

interface MilestoneScreenProps {
  title: string
  description: string | ReactNode
  warning?: string | ReactNode
}

export default function MilestoneScreen({
  title,
  description,
  warning,
}: MilestoneScreenProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: 3,
        px: 2,
      }}
    >
      <img
        src="/fundsorter-straight-arm.webp"
        alt="Fundsorter"
        style={{ height: 72, width: 'auto', marginBottom: 16 }}
      />
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: COLORS.primary,
          mb: 2,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: COLORS.labelText,
          maxWidth: 520,
          lineHeight: 1.6,
          ...(warning ? { mb: 2.5 } : {}),
        }}
      >
        {description}
      </Typography>

      {warning && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5,
            ...warningBoxSx,
            borderRadius: 3,
            p: 2.5,
            maxWidth: 520,
            textAlign: 'left',
          }}
        >
          <InfoOutlinedIcon
            sx={{ color: COLORS.warningIcon, fontSize: 22, mt: 0.25, flexShrink: 0 }}
          />
          <Typography variant="body2" sx={{ color: COLORS.labelText, lineHeight: 1.6 }}>
            {warning}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
